import moment from 'moment'
import * as routerNames from '@/services/router/router.names'

import CalendarScreen from '@/screens/calendar/calendar.vue'

export default [
  {
    path: '/:accountId/calendar/',
    name: routerNames.CALENDAR,
    component: CalendarScreen,
    beforeEnter: (to: any, from: any, next: any) => {
      if (!to.query.date) {
        to.query.date = moment().format('YYYY-MM-DD')
        next({ ...to, replace: true })
      }
      next()
    },
  },
]
